import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { bids } from '../../data/bids';
export function LatestBids() {
  const latestBids = bids.filter(b => b.status !== 'closed').slice(0, 4);
  return <section className="py-20 bg-white" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4" data-id="element-136">
        <SectionHeading title="Current Bids & Tenders" subtitle="Explore procurement opportunities and submit your proposals" data-id="element-137" />

        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-138">
          {latestBids.map((bid, index) => <motion.div key={bid.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-139">
              <Card hover data-id="element-140">
                <div className="flex items-start justify-between mb-3" data-id="element-141">
                  <span className="text-sm font-mono text-gray-500" data-id="element-142">
                    {bid.reference}
                  </span>
                  <StatusPill status={bid.status} data-id="element-143">
                    {bid.status === 'closing-soon' ? 'CLOSING SOON' : 'OPEN'}
                  </StatusPill>
                </div>
                <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-144">
                  {bid.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-145">{bid.description}</p>
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3" data-id="element-146">
                  <div className="flex items-center gap-1" data-id="element-147">
                    <CalendarIcon size={16} data-id="element-148" />
                    <span data-id="element-149">
                      Published:{' '}
                      {new Date(bid.publicationDate).toLocaleDateString('en-GB')}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-sm font-medium text-au-red mb-4" data-id="element-150">
                  <ClockIcon size={16} data-id="element-151" />
                  <span data-id="element-152">
                    Deadline:{' '}
                    {new Date(bid.deadline).toLocaleDateString('en-GB')}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-153">
                  <span className="text-sm text-gray-600" data-id="element-154">{bid.category}</span>
                  {bid.estimatedValue && <span className="text-sm font-bold text-charcoal" data-id="element-155">
                      {bid.estimatedValue}
                    </span>}
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-156">
          <Link to="/bids" data-id="element-157">
            <Button variant="primary" className="flex items-center gap-2 mx-auto" data-id="element-158">
              View All Bids
              <ArrowRightIcon size={20} data-id="element-159" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}